import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';



import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Container from '@mui/material/Container';

import styles from "./Testimonials.module.css";


function Testimonials(props) {


  const { testimonials, tindex, duration, playIcon, title } = props;
  // console.log(testimonials);

  let [index, setIndex] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(index === tindex ? 1 : index + 1);
    }, duration);
    return () => clearInterval(interval);
  }, [index]);

  return (

    <div className="Section">
      <Container maxWidth="lg">
    <div className={styles.TestimonialsContainer}>

      <h1>What our students are saying</h1>

      <div className={styles.M_TestimonialContainer} >
        <Paper className={styles.M_TestimonialVideoImg}
          variant="outlined"
          square
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            backgroundImage: `url('${testimonials[index - 1].image}')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover"
          }}
        >
          {playIcon &&
            <IconButton className={styles.videoPlayIcon}
              component="span">
              <PlayArrowIcon />
            </IconButton>
          }
        </Paper>

        <div className={styles.M_TestimonialRightCol}>



          <div className={styles.M_TestimonialDetails}>
            {title && <div className={styles.M_TestimonialTitle}>
              {testimonials[index - 1].review}
            </div>}

            <div className={styles.M_TestimonialDescription}>
              "{testimonials[index - 1].review}"
            </div>

            <div className={styles.M_TestimonialAurtherText}>
              {testimonials[index - 1].first_name} {testimonials[index - 1].last_name}
              <br />
              {testimonials[index - 1].orgFullName.length > 0?  testimonials[index - 1].orgFullName : testimonials[index - 1].indFirstName + testimonials[index - 1].indLastName}
            </div>
          </div>



          <div className={styles.M_TestimonialThumbnailContainer}>
            <Grid item lg={12} md={12} sm={12} xs={12} container={true} spacing={1}>
              {testimonials.map((data) => {
                return (
                  <Grid item>
                    <IconButton
                      size="small"
                      component="span"
                      onClick={() => setIndex(data.testimonialId)}
                     

                      className= {data.testimonialId === index ? "T_active" : "" }
                    >
                      <Avatar alt={data.first_name} src={data.image} className="AurtherThumbnail" />
                    </IconButton>
                  </Grid>
                );
              })}
            </Grid> 
          </div>


          <div className={styles.M_TestimonialArrowButton}>
            <IconButton className={`${styles.leftArrow} ${styles.TsArrow}`} 
              size="small"
              component="span"
              onClick={() => {
                setIndex(index === 1 ? index : index - 1);
              }}
            >
              <ArrowBackRoundedIcon fontSize="inherit" />
            </IconButton>
            <IconButton className={`${styles.leftArrow} ${styles.TsArrow}`} 
              size="small"
              component="span"
              onClick={() => {
                setIndex(index === tindex ? 1 : index + 1);
              }}
            >
              <ArrowForwardRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>

        </div>
      </div>
      
    </div>
    </Container>
    </div>
  );
}

export default Testimonials;
